export * from './customer-information-page.component';